// src/components/album/StepImageSelector.jsx
import React from 'react';
import {
    VStack,
    Heading,
    Box,
    Button,
    Text,
    SimpleGrid,
    Flex,
    Spinner,
    useBreakpointValue,
    useToast,
} from '@chakra-ui/react';
import { FiHome, FiTrash2 } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import AlbumImageCard from './AlbumImageCard';

const StepImageSelector = ({ 
    selectedImages, 
    isLoadingImages,
    onRemoveImage,
    onClearAll
}) => {
    const navigate = useNavigate();
    const toast = useToast();
    const buttonSize = useBreakpointValue({ base: "sm", md: "md" });
    const gridColumns = useBreakpointValue({ base: 1, sm: 2, md: 3 });

    const handleClearAll = () => {
        if (window.confirm("Tem certeza que deseja remover todas as imagens?")) {
            onClearAll();
            toast({
                title: "Todas as imagens removidas",
                status: "info",
                duration: 2000,
                isClosable: true,
            });
        }
    };

    return (
        <VStack spacing={6} align="stretch" w="100%">
            <Heading size="md" color="gray.700">
                Imagens Selecionadas ({selectedImages.length})
            </Heading>

            {isLoadingImages ? (
                <Flex justify="center" py={10}>
                    <Spinner size="xl" color="purple.500" thickness="4px" />
                </Flex>
            ) : selectedImages.length === 0 ? (
                <Box 
                    p={8} 
                    bg="white" 
                    borderRadius="lg" 
                    borderWidth="1px" 
                    borderColor="gray.200" 
                    textAlign="center"
                >
                    <VStack spacing={4}>
                        <Text fontSize="lg" color="gray.500">
                            Nenhuma imagem selecionada
                        </Text>
                        <Text color="gray.500">
                            Volte à galeria e selecione imagens clicando no botão "Adicionar ao Livro"
                        </Text>
                        <Button
                            leftIcon={<FiHome />}
                            colorScheme="blue"
                            onClick={() => navigate('/dashboard')}
                            size={buttonSize}
                        >
                            Voltar à Galeria
                        </Button>
                    </VStack>
                </Box>
            ) : (
                <>
                    <SimpleGrid columns={gridColumns} spacing={4} w="100%">
                        {selectedImages.map((image, index) => (
                            <AlbumImageCard
                                key={image.id}
                                image={image}
                                index={index}
                                onRemove={onRemoveImage}
                            />
                        ))}
                    </SimpleGrid>
                    
                    <Flex 
                        justify="center" 
                        mt={4} 
                        direction={{ base: "column", sm: "row" }} 
                        gap={4}
                    >
                        <Button
                            leftIcon={<FiHome />}
                            colorScheme="blue"
                            variant="outline"
                            onClick={() => navigate('/dashboard')}
                            size={buttonSize}
                            width={{ base: "100%", sm: "auto" }}
                        >
                            Adicionar mais imagens
                        </Button>
                        <Button
                            colorScheme="red"
                            variant="outline"
                            leftIcon={<FiTrash2 />}
                            onClick={handleClearAll}
                            size={buttonSize}
                            width={{ base: "100%", sm: "auto" }}
                        >
                            Limpar seleção
                        </Button>
                    </Flex>
                </>
            )}
        </VStack>
    );
};

export default StepImageSelector;